import React from 'react';
import { Logo } from '../ui/Logo';
interface BrandLogoProps {
  /** Logotipo propio de la empresa. Si no existe, se usa el logo del Sistema AVA. */
  src?: string;
  size?: number;
  showWordmark?: boolean;
  alt?: string;
  className?: string;
}

/**
 * Punto único donde se resuelve el logotipo mostrado en toda la plataforma:
 * sidebar, dashboard, landings, formularios, footer y página de gracias.
 */
export function BrandLogo({
  src,
  size = 28,
  showWordmark = true,
  alt = 'Logotipo',
  className = ''
}: BrandLogoProps) {
  if (src) {
    return <img src={src} alt={alt} style={{
      height: Math.round(size * 1.5)
    }} className={`w-auto max-w-[140px] object-contain sm:max-w-[200px] ${className}`} data-id="element-799" data-mp="3pjc6vkg171tn" />;
  }
  return <Logo size={size} showWordmark={showWordmark} className={className} data-id="element-800" data-mp="3fqwq2qgh0jac" />;
}